// This module provides API call methods for Sephora Commerce CMS API:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Sephora+Commerce+CMS+API+Specification

const { getMediaContent, getMediaContentByScreen, getRwdMediaContent } = require('services/api/cms/getMediaContent');
const { getUFEComponentContent } = require('services/api/cms/getUFEComponentContent');

module.exports = {
    getMediaContent,
    getMediaContentByScreen,
    getUFEComponentContent,
    getRwdMediaContent
};
